import { useMemo } from 'react';

import { settings, useSetting } from '@work4all/data/lib/settings';

interface Return {
  maximumFractionDigits: number;
  minimumFractionDigits: number;
}

export const useStatisticsDecimals = (): Return => {
  const statisticsShowDecimals = useSetting(settings.statisticsShowDecimals());

  return useMemo(() => {
    const fractionDigits = statisticsShowDecimals.value ? 2 : 0;

    return {
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    };
  }, [statisticsShowDecimals.value]);
};
